import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutoCompletTabSelected } from './autocomplete-tab.directive';

@NgModule({
  declarations: [AutoCompletTabSelected],
  imports: [
    CommonModule
  ],
  exports: [
    AutoCompletTabSelected
  ]
})
export class AutoCompletTabModule { }
